import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './index.scss';

const PageTransition = ({ children }) => {
    const location = useLocation();
    const [displayLocation, setDisplayLocation] = useState(location);
    const [transitionStage, setTransitionStage] = useState('entering');

    useEffect(() => {
        if (location.pathname !== displayLocation.pathname) {
            setTransitionStage('exiting');
        }
    }, [location.pathname, displayLocation.pathname]);

    const onExitingTransitionEnd = () => {
        if (transitionStage === 'exiting') {
            setDisplayLocation(location);
            setTransitionStage('entering');
        }
    };

    return (
        <div
            className={`page-transition page-transition-${transitionStage}`}
            onAnimationEnd={onExitingTransitionEnd}
        >
            {children}
        </div>
    );
};

export default PageTransition;

